/**
 * The toast for a shift opened or closed on another terminal (a syncTerminals 'Shift' push).
 * The push reaches every terminal of the venue, but a shift belongs to one cash register: only
 * the devices on that register — its other terminals and the ordering devices linked to it —
 * are told. Every other register, and a terminal without one (a kitchen display), stays silent.
 * The terminal that opened or closed the shift never handles its own push (AppEvent hash dedup);
 * it toasts from useSales.
 */
export type ShiftToastKey = 'general.shift_opened' | 'general.shift_closed'

export function shiftBroadcastToast(
    records: { cash_register_id?: number | null }[],
    cashRegisterId: number | null | undefined,
    hasOpenShift: boolean,
): ShiftToastKey | null {
    const forThisCashRegister = !!cashRegisterId && records.some(record => record.cash_register_id === cashRegisterId)
    if (!forThisCashRegister) return null

    return hasOpenShift ? 'general.shift_opened' : 'general.shift_closed'
}
